export const SHOW_ERROR_NOTIFICATION = "SHOW_ERROR_NOTIFICATION";
export const SHOW_SUCCESS_NOTIFICATION = "SHOW_SUCCESS_NOTIFICATION";
export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";



// WEBPACK FOOTER //
// ./src/actions/notifications/types.js